import styled from "@emotion/styled";
import {
  Grids,
  MediaQueries,
  Spacings,
} from "@polestar/component-warehouse-react";

export const StyledCell = styled.div`
  grid-column: span ${Grids.tablet.columns};

  ${MediaQueries.tablet} {
    grid-column: 1 / span 7;
  }

  ${MediaQueries.desktop} {
    grid-column: 1 / span 5;

    &:nth-of-type(2) {
      grid-column: 6 / span 5;
    }
  }
`;

export const StyledImageCell = styled.div`
  margin-bottom: ${Spacings.small};
  margin-left: -${Spacings.small};

  ${MediaQueries.tablet} {
    margin-bottom: ${Spacings.medium};
    margin-left: -${Spacings.large};
  }

  ${MediaQueries.desktop} {
    margin-bottom: 0;
    margin-left: 0;
  }
`;

export const StyledTextCell = styled.div`
  margin-top: ${Spacings.small};
  margin-bottom: ${Spacings.medium};

  ${MediaQueries.tablet} {
    max-width: 440px;
    margin-bottom: ${Spacings.large};
  }

  ${MediaQueries.desktop} {
    max-width: 288px;
    margin-bottom: 0;
  }

  ${MediaQueries.desktopWide} {
    max-width: 384px;
  }
`;
